import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  breadCrumbsPagePath: '',
};

const pageActionsReducer = createSlice({
  name: 'pageactions',
  initialState: initialState,
  reducers: {
    setPagePath: (state, action: any) => {
      state.breadCrumbsPagePath = action.payload;
    },
  },
});

export const pageActions = pageActionsReducer.actions;
export default pageActionsReducer;
